import type {FormControlOptions, UpdateTrigger} from '../../forms/types';
import {defaultUpdateTriggers} from '../../forms/form-control';
import {isNullOrUndefined} from '../../../../utils/custom-utils';
import {AUTOCOMPLETE_INPUT_EVENT} from '../../../../ui-widgets/autocomplete/utils';


export function createAutocompleteFormControlOptions(formControlOptions: FormControlOptions): FormControlOptions {
    if (isNullOrUndefined(formControlOptions)) {
        return {updateTriggers: [...AUTOCOMPLETE_TRIGGERS]};
    }

    if (isNullOrUndefined(formControlOptions.updateTriggers)) {
        return {...formControlOptions, updateTriggers: [...AUTOCOMPLETE_TRIGGERS]};
    }

    return {...formControlOptions, updateTriggers: addAutocompleteTrigger(formControlOptions.updateTriggers)};
}

const AUTOCOMPLETE_TRIGGERS = [defaultUpdateTriggers.BLUR, defaultUpdateTriggers.INPUT, {eventName: AUTOCOMPLETE_INPUT_EVENT}];


function addAutocompleteTrigger(updateTriggers: UpdateTrigger[]): UpdateTrigger[] {
    if (updateTriggers.length === 0) { // null, undefined, empty
        return updateTriggers;
    }

    const inputTrigger = updateTriggers.find((trigger) => trigger.eventName === defaultUpdateTriggers.INPUT.eventName);
    if (isNullOrUndefined(inputTrigger)) {
        return [...updateTriggers, {eventName: AUTOCOMPLETE_INPUT_EVENT, debounceValue: updateTriggers[0].debounceValue}]; // copy debounce of first trigger
    }

    return [...updateTriggers, {eventName: AUTOCOMPLETE_INPUT_EVENT, debounceValue: inputTrigger.debounceValue}];
}